import { render, staticRenderFns } from "./dev-use-elec-statistics.vue?vue&type=template&id=fbe2d13a&scoped=true&"
import script from "./dev-use-elec-statistics.vue?vue&type=script&lang=js&"
export * from "./dev-use-elec-statistics.vue?vue&type=script&lang=js&"
import style0 from "./dev-use-elec-statistics.vue?vue&type=style&index=0&id=fbe2d13a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe2d13a",
  null
  
)

export default component.exports